//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    cover: {
      type: String,
      default: '',
    },
    detail: {
      type: String,
      default: '',
    },
    guests: {
      type: Array,
      default: () => [],
    },
    description: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
}
